class RegisterValidator extends HTMLElement {
    constructor() {
        super();
        this.form = null;
        this.inputs = {};
        this.prevLabels = {};
    }

    connectedCallback() {
        this.form = this.querySelector('form');
        this.submitBtn = this.querySelector('button[type="submit"]')
        this.inputs = {
            FirstName: this.querySelector('#RegisterForm-FirstName'),
            LastName: this.querySelector('#RegisterForm-LastName'),
            Email: this.querySelector('#RegisterForm-email'),
            Password: this.querySelector('#RegisterForm-password'),
            PasswordConfirmation: this.querySelector('#RegisterForm-confirmPassword')
        };


        this.submitBtn.addEventListener('click', event => this.onSubmit(event));

    }

    onSubmit(event) {
        const errorsPresent = this.checkErrors();

        if (errorsPresent) {
            event.preventDefault();
            event.stopPropagation();
        }
    }

    checkErrors() {
        let errorsPresent = false;
        const passwordLabel = this.inputs.Password.previousElementSibling
        const confirmLabel = this.inputs.PasswordConfirmation.previousElementSibling

        Array.from([this.inputs.FirstName,  this.inputs.LastName, this.inputs.Email, this.inputs.Password])
            .forEach(input => {
                input.previousElementSibling.innerText = this.prevLabels[input.id] || input.previousElementSibling.innerText
                input.previousElementSibling.classList.toggle('error', !input.value)
                if (!input.value) {
                    errorsPresent = true;
                    this.prevLabels[input.id] = input.previousElementSibling.innerText
                    input.previousElementSibling.innerText += ` ${ window.formErrors.fieldBlank}`
                }
            })

        if (this.inputs.Password.value !== this.inputs.PasswordConfirmation.value) {
            errorsPresent = true;
            passwordLabel.innerText = window.formErrors.passwordsNotMatching
            confirmLabel.innerText = window.formErrors.passwordsNotMatching

            passwordLabel.classList.add('error')
            confirmLabel.classList.add('error')
        }

        return errorsPresent;
    }
}

customElements.define('register-validator', RegisterValidator);